import { useDispatch } from 'react-redux';
import { LAYER } from 'js/components/common/PopupManager';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { useCallback } from 'react';

export const useShowTermsPopup = ({ termAndConditionWebContentId }) => {
    const dispatch = useDispatch();

    return useCallback((event) => {
        event.preventDefault();

        dispatch(showCommonPopupAction({
            layer: LAYER.MULTIVIEW_BONUS_TC,
            title: 'playtech.mobile.system.bonus-multi-view.tc',
            articleId: termAndConditionWebContentId
        }));
    }, [
        dispatch,
        termAndConditionWebContentId
    ]);
};
